module.exports = __webpack_public_path__ + "media/images/logo_tr-dcf697f725f9f1d4c23340e9e2a61b71.svg";